import { calculatePlanogramItemsPositions } from '../../../common/utils/planograms/planogram';

export const toNonNegativeNumber = (value) => {
	const numericValue = Number(value);
	if (!Number.isFinite(numericValue)) {
		return 0;
	}
	return Math.max(0, numericValue);
};

export const getPickedQuantity = (item) => {
	return toNonNegativeNumber(item?.pickedQuantity) + toNonNegativeNumber(item?.pickedExtraQuantity);
};

export const normalizeExpiryDatesForSave = (expiryDates = {}) => {
	return Object.keys(expiryDates || {}).reduce((acc, key) => {
		const value = expiryDates?.[key];
		if (!value) {
			acc[key] = null;
			return acc;
		}

		const parsedDate = new Date(value);
		acc[key] = Number.isNaN(parsedDate.getTime()) ? null : parsedDate.toISOString();
		return acc;
	}, {});
};

export const createMappedItems = (pickList) => {

	let stockPickListItems = pickList.pickListItems;
	stockPickListItems = calculatePlanogramItemsPositions({
		items: stockPickListItems,
		planogramItemGroups: pickList.machine.planogram.planogramItemGroups,
		planogramItemField: 'planogramItem',
	});

	return stockPickListItems.map(item => {
		const hasPickedQuantity = (item.isPicked && toNonNegativeNumber(item.quantity) > 0) ||
			(item.extraQuantityIsPicked && toNonNegativeNumber(item.extraQuantity) > 0);
		const expiryDatesAtPick = item.planogramItemExpiryDatesAtPick || null;
		const planogramExpiryDates = item.planogramItem?.expiryDates || {};
		const displayExpiryDates = hasPickedQuantity ? expiryDatesAtPick : null;

		const stockPickListItem = ({
			...item.planogramItem,					// Map in the planogramItem
			expiryDates: displayExpiryDates,
			expiryDatesArePickedWarehouseStock: true,
			requiredQuantity: item.quantity + item.extraQuantity,
			product: {
				...item.product,					// Add in the product as a child of planogramItem
			},
			productName: item.product ? item.product.name : null,
			removedProduct: {
				...item.removedProduct,				// Add in any removed products (can spread null when none);
			},
			pickedQuantity: item.isPicked ? item.quantity : 0,
			pickedExtraQuantity: item.extraQuantityIsPicked ? item.extraQuantity : 0,
			extraQuantity: item.extraQuantity || 0,
			planogramItemQuantity: item.planogramItemQuantity,
			planogramItemQuantityPostService: item.planogramItemQuantityPostService,
			planogramItemQuantityPostInventoryChange: item.planogramItemQuantityPostInventoryChange,
			planogramItemExpiryDatesAtPick: expiryDatesAtPick,
			planogramExpiryDates,
			suggestedExpiryDatesFromWarehouse: item.suggestedExpiryDatesFromWarehouse,
			id: item.id,
			planogramItemId: item.planogramItem.id,
			pickOrder: item.pickOrder,
			isPicked: item.isPicked,
			extraQuantityIsPicked: item.extraQuantityIsPicked,
			tubWeightExcludedQuantity: toNonNegativeNumber(item.tubWeightExcludedQuantity),
			inactive: item.planogramItem.inactive,
		});

		return stockPickListItem;
	});
};
